const BUTTON_TYPES = {
  SITE_LINK: "siteLink",
  EXTERNAL_LINK: "externalLink",
  PHONE_NUMBER: "phoneNumber",
  EMAIL: "email",
};

export default BUTTON_TYPES;
